import React from "react";
import img1 from "../Assests/Diabetes/diabetes_vector.png";
import img2 from "../Assests/Diabetes/wellness.png";
import Arrow from "../Assests/Diabetes/arrow_1.png";
import { Link } from "react-router-dom";
import Footer from "../Home/Footer";
import Header from "../Home/Navbar";

const Clinical_Study = () => {
  return (
    <div>
      <Header />
      <div className="clinical-container" id="clinical-study">
        <div className="clinical-container1">
          <p>Clinical Study</p>
          <p>On Whole-system medicine based AIWeLL™ Protocols</p>
        </div>
        <div className="clinical-container2">
          <div className="clinical-container2-inner">
            <div className="clinical-container2-inner2 mb-6">
              <img src={img1} className="clinical-img" />
            </div>
            <p className="clinical-container2-inner-p mb-6">
              Diabetes & Pre-diabetes
            </p>
            <Link to="/clinicalStudies/diabetes">
              <div className="clinical-container2-inner1">
                <p className="clinical-container2-inner1-p ">
                View AIWeLL DM™ Protocol details
                </p>
                <img src={Arrow} className="clinical-arrow w-10 h-10" />
              </div>
            </Link>
          </div>
          <div className="clinical-container2-inner">
            <div className="clinical-container2-inner2 mb-6">
              <img src={img2} className="clinical-img" />
            </div>
            <p className="clinical-container2-inner-p mb-6">
              Gastric, Metabolic, & Women’s wellness
            </p>
            <Link to="/clinicalStudies/wellness">
              <div className="clinical-container2-inner1">
                <p className="clinical-container2-inner1-p">
                  View AIWeLL™ Wellness Protocol details
                </p>
                <img src={Arrow} className="clinical-arrow w-10 h-10" />
              </div>
            </Link>
          </div>
        </div>
        <div className="clinical-container3">
          <p>How to Join?</p>
          {/* <p>A Whole system medicine based AIWeLL DM™ Protocol</p> */}
        </div>
        <div className="clinical-container4 ">
          <div className="clinical-container4-part1 pb-10">
            <p>STEP 1</p>
            <p>Click View study details and Express Interest</p>
          </div>
          <div className="clinical-container4-part1  ">
            <p>STEP 2</p>
            <p>Complete a short screening questionnaire</p>
          </div>
          <div className="clinical-container4-part2 ">
            <p>STEP 3</p>
            <p>If eligible, our team will contact you</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default Clinical_Study;
